<template>
  <Transition name="timesheet-frequency-modal-overlay">
    <div
      v-if="visible"
      class="timesheet-frequency-modal-overlay timesheet-frequency-modal-overlay--glass"
      @click.self="$emit('cancel')"
    >
      <Transition name="timesheet-frequency-modal-panel" appear>
        <div
          v-if="visible"
          class="timesheet-frequency-modal-card timesheet-frequency-modal-card--glass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="timesheet-frequency-modal-title"
          @click.stop
        >
          <div class="timesheet-frequency-modal-header timesheet-frequency-modal-header--glass">
            <h2 id="timesheet-frequency-modal-title" class="timesheet-frequency-modal-title">
              Timesheet Frequency
            </h2>
            <button
              type="button"
              class="timesheet-frequency-modal-close-btn"
              aria-label="Close"
              title="Close"
              @click="$emit('cancel')"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>

          <div class="timesheet-frequency-modal-body timesheet-frequency-modal-body--glass">
            <LabelInputField
              input-id="timesheet-frequency-name"
              label="Name"
              v-model="frequencyName"
              placeholder="e.g. Weekly"
              required
              flex
              :has-error="!!error"
              :disabled="saving"
              @input="error = ''"
            >
              <div v-if="error" class="timesheet-frequency-modal-error">{{ error }}</div>
            </LabelInputField>
          </div>

          <div class="timesheet-frequency-modal-actions timesheet-frequency-modal-actions--glass">
            <SecondaryButton label="Cancel" :disabled="saving" @click="$emit('cancel')" />
            <PrimaryButton label="Save" :loading="saving" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>

  <ErrorModal
    :show="showErrorModal"
    title="Validation Error"
    :message="errorMessage"
    buttonText="OK"
    @close="closeErrorModal"
  />
</template>

<script>
import '../styles/AddNewTimesheetFrequency.css';
import CompanyService from '@/services/company.service.js';
import ErrorModal from '@/components/ErrorModal.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'AddNewTimesheetFrequency',
  components: {
    ErrorModal,
    LabelInputField,
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      frequencyName: '',
      error: '',
      saving: false,
      showErrorModal: false,
      errorMessage: '',
    };
  },
  methods: {
    async ok() {
      if (!this.frequencyName.trim()) {
        this.error = 'Name field is required.';
        return;
      }
      this.saving = true;
      this.error = '';
      try {
        const frequency = await CompanyService.createTimesheetFrequency({
          name: this.frequencyName.trim(),
          companyId: this.companyId,
        });
        this.$emit('ok', frequency);
        this.frequencyName = '';
        this.error = '';
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message || err.message || 'Failed to create timesheet frequency.';
        this.showErrorModal = true;
      } finally {
        this.saving = false;
      }
    },
    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
  },
};
</script>
